<div class="admin-container">
    <h1>Users List</h1>
    <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Username</th>
          <th>Email</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>{{ user.id }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.email }}</td>
          <td>
            <button (click)="editUser(user.id.toString())">Edit</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>